//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as jQuery from 'jquery';

export class V1Client {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://geo.api.vlaanderen.be/geolocation";
    }

    /**
     * Provides auto-completion functionality for a free form single search line.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param capakey (optional) <b>Obsolete</b> [Optional] A parcel identifier in capakey notation. At least the first five characters are required.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 25 items. If omitted defaults to 5.
     * @return OK
     */
    suggestion(q?: string | null | undefined, capakey?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<SuggestionResponse>((resolve, reject) => {
            this.suggestionWithCallbacks(q, capakey, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private suggestionWithCallbacks(q: string | null | undefined, capakey: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: SuggestionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v1/Suggestion?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (capakey !== undefined && capakey !== null)
            url_ += "capakey=" + encodeURIComponent("" + capakey) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSuggestionWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSuggestion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSuggestion(xhr: any): SuggestionResponse | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionResponse.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Geocoding provides the location of an address. Reverse geocoding provides the closest address based on a given location.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param latlon (optional) [Optional] A coordinate in WGS84 projection. Input takes the form [lat,lon] where <i>lat</i> and <i>lon</i> are provided in decimal degrees.
     * @param xy (optional) [Optional] A coordinate in Lambert-72 projection. Input takes the form [x,y] where <i>x</i> and <i>y</i> are provided in meters.
     * @param capakey (optional) <b>Obsolete</b> [Optional] A parcel identifier in capakey notation. At least the first five characters are required.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 5 items. If omitted defaults to 1.
     * @return OK
     */
    location(q?: string | null | undefined, latlon?: string | null | undefined, xy?: string | null | undefined, capakey?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<LocationResponse>((resolve, reject) => {
            this.locationWithCallbacks(q, latlon, xy, capakey, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private locationWithCallbacks(q: string | null | undefined, latlon: string | null | undefined, xy: string | null | undefined, capakey: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: LocationResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v1/Location?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (latlon !== undefined && latlon !== null)
            url_ += "latlon=" + encodeURIComponent("" + latlon) + "&";
        if (xy !== undefined && xy !== null)
            url_ += "xy=" + encodeURIComponent("" + xy) + "&";
        if (capakey !== undefined && capakey !== null)
            url_ += "capakey=" + encodeURIComponent("" + capakey) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLocationWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLocation(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLocation(xhr: any): LocationResponse | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponse.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class V2Client {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://geo.api.vlaanderen.be/geolocation";
    }

    /**
     * Provides auto-completion functionality for a free form single search line.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param capakey (optional) <b>Obsolete</b> [Optional] A parcel identifier in capakey notation. At least the first five characters are required.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 25 items. If omitted defaults to 5.
     * @return OK
     */
    suggestion(q?: string | null | undefined, capakey?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<SuggestionResponseV2>((resolve, reject) => {
            this.suggestionWithCallbacks(q, capakey, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private suggestionWithCallbacks(q: string | null | undefined, capakey: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: SuggestionResponseV2) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v2/Suggestion?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (capakey !== undefined && capakey !== null)
            url_ += "capakey=" + encodeURIComponent("" + capakey) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSuggestionWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSuggestion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSuggestion(xhr: any): SuggestionResponseV2 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionResponseV2.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Geocoding provides the location of an address. Reverse geocoding provides the closest address based on a given location.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param latlon (optional) [Optional] A coordinate in WGS84 projection. Input takes the form [lat,lon] where <i>lat</i> and <i>lon</i> are provided in decimal degrees.
     * @param xy (optional) [Optional] A coordinate in Lambert-72 projection. Input takes the form [x,y] where <i>x</i> and <i>y</i> are provided in meters.
     * @param capakey (optional) <b>Obsolete</b> [Optional] A parcel identifier in capakey notation. At least the first five characters are required.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 5 items. If omitted defaults to 1.
     * @return OK
     */
    location(q?: string | null | undefined, latlon?: string | null | undefined, xy?: string | null | undefined, capakey?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<LocationResponseV2>((resolve, reject) => {
            this.locationWithCallbacks(q, latlon, xy, capakey, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private locationWithCallbacks(q: string | null | undefined, latlon: string | null | undefined, xy: string | null | undefined, capakey: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: LocationResponseV2) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v2/Location?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (latlon !== undefined && latlon !== null)
            url_ += "latlon=" + encodeURIComponent("" + latlon) + "&";
        if (xy !== undefined && xy !== null)
            url_ += "xy=" + encodeURIComponent("" + xy) + "&";
        if (capakey !== undefined && capakey !== null)
            url_ += "capakey=" + encodeURIComponent("" + capakey) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLocationWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLocation(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLocation(xhr: any): LocationResponseV2 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponseV2.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class V3Client {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://geo.api.vlaanderen.be/geolocation";
    }

    /**
     * Provides auto-completion functionality for a free form single search line.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 25 items. If omitted defaults to 5.
     * @return OK
     */
    suggestion(q?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<SuggestionResponseV3>((resolve, reject) => {
            this.suggestionWithCallbacks(q, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private suggestionWithCallbacks(q: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: SuggestionResponseV3) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v3/Suggestion?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSuggestionWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSuggestion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSuggestion(xhr: any): SuggestionResponseV3 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionResponseV3.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Geocoding provides the location of an address. Reverse geocoding provides the closest address based on a given location.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param latlon (optional) [Optional] A coordinate in WGS84 projection. Input takes the form [lat,lon] where <i>lat</i> and <i>lon</i> are provided in decimal degrees.
     * @param xy (optional) [Optional] A coordinate in Lambert-72 projection. Input takes the form [x,y] where <i>x</i> and <i>y</i> are provided in meters.
     * @param poi (optional) <b>Obsolete</b> [Optional] The name of a Point of Interest, or a part thereof.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 5 items. If omitted defaults to 1.
     * @return OK
     */
    location(q?: string | null | undefined, latlon?: string | null | undefined, xy?: string | null | undefined, poi?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<LocationResponseV3>((resolve, reject) => {
            this.locationWithCallbacks(q, latlon, xy, poi, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private locationWithCallbacks(q: string | null | undefined, latlon: string | null | undefined, xy: string | null | undefined, poi: string | null | undefined, c: number | null | undefined, onSuccess?: (result: LocationResponseV3) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v3/Location?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (latlon !== undefined && latlon !== null)
            url_ += "latlon=" + encodeURIComponent("" + latlon) + "&";
        if (xy !== undefined && xy !== null)
            url_ += "xy=" + encodeURIComponent("" + xy) + "&";
        if (poi !== undefined && poi !== null)
            url_ += "poi=" + encodeURIComponent("" + poi) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLocationWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLocation(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLocation(xhr: any): LocationResponseV3 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponseV3.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class V4Client {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://geo.api.vlaanderen.be/geolocation";
    }

    /**
     * Provides auto-completion functionality for a free form single search line.
     * @param q (optional) A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 25 items. If omitted defaults to 5.
     * @return OK
     */
    suggestion(q?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<SuggestionResponseV4>((resolve, reject) => {
            this.suggestionWithCallbacks(q, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private suggestionWithCallbacks(q: string | null | undefined, c: number | null | undefined, onSuccess?: (result: SuggestionResponseV4) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v4/Suggestion?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSuggestionWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSuggestion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSuggestion(xhr: any): SuggestionResponseV4 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionResponseV4.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Geocoding provides the location of an address. Reverse geocoding provides the closest address based on a given location.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param latlon (optional) [Optional] A coordinate in WGS84 projection. Input takes the form [lat,lon] where <i>lat</i> and <i>lon</i> are provided in decimal degrees.
     * @param xy (optional) [Optional] A coordinate in Lambert-72 projection. Input takes the form [x,y] where <i>x</i> and <i>y</i> are provided in meters.
     * @param type (optional) [Optional] The location types you want to restrict the result to. Valid types are 'Municipality' (1), 'Thoroughfarename' (2), 'Housenumber' (3). The filter has no effect on reverse geocoding requests.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 5 items. If omitted defaults to 1.
     * @return OK
     */
    location(q?: string | null | undefined, latlon?: string | null | undefined, xy?: string | null | undefined, type?: Type | null | undefined, c?: number | null | undefined) {
        return new Promise<LocationResponseV4>((resolve, reject) => {
            this.locationWithCallbacks(q, latlon, xy, type, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private locationWithCallbacks(q: string | null | undefined, latlon: string | null | undefined, xy: string | null | undefined, type: Type | null | undefined, c: number | null | undefined, onSuccess?: (result: LocationResponseV4) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/v4/Location?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (latlon !== undefined && latlon !== null)
            url_ += "latlon=" + encodeURIComponent("" + latlon) + "&";
        if (xy !== undefined && xy !== null)
            url_ += "xy=" + encodeURIComponent("" + xy) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLocationWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLocation(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLocation(xhr: any): LocationResponseV4 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponseV4.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GeolocationClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://geo.api.vlaanderen.be/geolocation";
    }

    /**
     * Provides auto-completion functionality for a free form single search line.
     * @param q (optional) A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 25 items. If omitted defaults to 5.
     * @return OK
     */
    suggestion(q?: string | null | undefined, c?: number | null | undefined) {
        return new Promise<SuggestionResponseV4>((resolve, reject) => {
            this.suggestionWithCallbacks(q, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private suggestionWithCallbacks(q: string | null | undefined, c: number | null | undefined, onSuccess?: (result: SuggestionResponseV4) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/geolocation/Suggestion?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSuggestionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSuggestionWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSuggestion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSuggestion(xhr: any): SuggestionResponseV4 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionResponseV4.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Geocoding provides the location of an address. Reverse geocoding provides the closest address based on a given location.
     * @param q (optional) [Optional] A free form search string. May contain community names, sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param latlon (optional) [Optional] A coordinate in WGS84 projection. Input takes the form [lat,lon] where <i>lat</i> and <i>lon</i> are provided in decimal degrees.
     * @param xy (optional) [Optional] A coordinate in Lambert-72 projection. Input takes the form [x,y] where <i>x</i> and <i>y</i> are provided in meters.
     * @param type (optional) [Optional] The location types you want to restrict the result to. Valid types are 'Municipality' (1), 'Thoroughfarename' (2), 'Housenumber' (3). The filter has no effect on reverse geocoding requests.
     * @param c (optional) [Optional] The maximum number of items you want to retrieve in the result. You may not ask more than 5 items. If omitted defaults to 1.
     * @return OK
     */
    location(q?: string | null | undefined, latlon?: string | null | undefined, xy?: string | null | undefined, type?: Type2 | null | undefined, c?: number | null | undefined) {
        return new Promise<LocationResponseV4>((resolve, reject) => {
            this.locationWithCallbacks(q, latlon, xy, type, c, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private locationWithCallbacks(q: string | null | undefined, latlon: string | null | undefined, xy: string | null | undefined, type: Type2 | null | undefined, c: number | null | undefined, onSuccess?: (result: LocationResponseV4) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/geolocation/Location?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (latlon !== undefined && latlon !== null)
            url_ += "latlon=" + encodeURIComponent("" + latlon) + "&";
        if (xy !== undefined && xy !== null)
            url_ += "xy=" + encodeURIComponent("" + xy) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (c !== undefined && c !== null)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLocationWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLocationWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLocation(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLocation(xhr: any): LocationResponseV4 | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponseV4.fromJS(resultData200);
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

/** A collection of address suggestions. */
export class SuggestionResponse implements ISuggestionResponse {
    suggestionResult!: string[] | undefined;

    constructor(data?: ISuggestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SuggestionResult"])) {
                this.suggestionResult = [] as any;
                for (let item of _data["SuggestionResult"])
                    this.suggestionResult!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestionResult)) {
            data["SuggestionResult"] = [];
            for (let item of this.suggestionResult)
                data["SuggestionResult"].push(item);
        }
        return data;
    }
}

/** A collection of address suggestions. */
export interface ISuggestionResponse {
    suggestionResult: string[] | undefined;
}

export class LocationResponse implements ILocationResponse {
    locationResult!: LocationResult[] | undefined;

    constructor(data?: ILocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LocationResult"])) {
                this.locationResult = [] as any;
                for (let item of _data["LocationResult"])
                    this.locationResult!.push(LocationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationResult)) {
            data["LocationResult"] = [];
            for (let item of this.locationResult)
                data["LocationResult"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationResponse {
    locationResult: LocationResult[] | undefined;
}

export class LocationResult implements ILocationResult {
    formattedAddress!: string | undefined;
    location!: Location | undefined;
    locationType!: string | undefined;
    boundingBox!: BoundingBox | undefined;

    constructor(data?: ILocationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formattedAddress = _data["FormattedAddress"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.locationType = _data["LocationType"];
            this.boundingBox = _data["BoundingBox"] ? BoundingBox.fromJS(_data["BoundingBox"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FormattedAddress"] = this.formattedAddress;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["LocationType"] = this.locationType;
        data["BoundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationResult {
    formattedAddress: string | undefined;
    location: Location | undefined;
    locationType: string | undefined;
    boundingBox: BoundingBox | undefined;
}

export class Location implements ILocation {
    lat_WGS84!: number | undefined;
    lon_WGS84!: number | undefined;
    x_Lambert72!: number | undefined;
    y_Lambert72!: number | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat_WGS84 = _data["Lat_WGS84"];
            this.lon_WGS84 = _data["Lon_WGS84"];
            this.x_Lambert72 = _data["X_Lambert72"];
            this.y_Lambert72 = _data["Y_Lambert72"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat_WGS84"] = this.lat_WGS84;
        data["Lon_WGS84"] = this.lon_WGS84;
        data["X_Lambert72"] = this.x_Lambert72;
        data["Y_Lambert72"] = this.y_Lambert72;
        return data;
    }
}

export interface ILocation {
    lat_WGS84: number | undefined;
    lon_WGS84: number | undefined;
    x_Lambert72: number | undefined;
    y_Lambert72: number | undefined;
}

export class BoundingBox implements IBoundingBox {
    lowerLeft!: Location | undefined;
    upperRight!: Location | undefined;

    constructor(data?: IBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowerLeft = _data["LowerLeft"] ? Location.fromJS(_data["LowerLeft"]) : <any>undefined;
            this.upperRight = _data["UpperRight"] ? Location.fromJS(_data["UpperRight"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LowerLeft"] = this.lowerLeft ? this.lowerLeft.toJSON() : <any>undefined;
        data["UpperRight"] = this.upperRight ? this.upperRight.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBoundingBox {
    lowerLeft: Location | undefined;
    upperRight: Location | undefined;
}

export class SuggestionResponseV2 implements ISuggestionResponseV2 {
    suggestionResult!: string[] | undefined;

    constructor(data?: ISuggestionResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SuggestionResult"])) {
                this.suggestionResult = [] as any;
                for (let item of _data["SuggestionResult"])
                    this.suggestionResult!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestionResult)) {
            data["SuggestionResult"] = [];
            for (let item of this.suggestionResult)
                data["SuggestionResult"].push(item);
        }
        return data;
    }
}

export interface ISuggestionResponseV2 {
    suggestionResult: string[] | undefined;
}

export class LocationResponseV2 implements ILocationResponseV2 {
    locationResult!: LocationResult[] | undefined;

    constructor(data?: ILocationResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LocationResult"])) {
                this.locationResult = [] as any;
                for (let item of _data["LocationResult"])
                    this.locationResult!.push(LocationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationResult)) {
            data["LocationResult"] = [];
            for (let item of this.locationResult)
                data["LocationResult"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationResponseV2 {
    locationResult: LocationResult[] | undefined;
}

export class SuggestionResponseV3 implements ISuggestionResponseV3 {
    suggestionResult!: string[] | undefined;

    constructor(data?: ISuggestionResponseV3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SuggestionResult"])) {
                this.suggestionResult = [] as any;
                for (let item of _data["SuggestionResult"])
                    this.suggestionResult!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionResponseV3 {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionResponseV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestionResult)) {
            data["SuggestionResult"] = [];
            for (let item of this.suggestionResult)
                data["SuggestionResult"].push(item);
        }
        return data;
    }
}

export interface ISuggestionResponseV3 {
    suggestionResult: string[] | undefined;
}

export class LocationResponseV3 implements ILocationResponseV3 {
    locationResult!: LocationResultV3[] | undefined;

    constructor(data?: ILocationResponseV3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LocationResult"])) {
                this.locationResult = [] as any;
                for (let item of _data["LocationResult"])
                    this.locationResult!.push(LocationResultV3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationResponseV3 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResponseV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationResult)) {
            data["LocationResult"] = [];
            for (let item of this.locationResult)
                data["LocationResult"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationResponseV3 {
    locationResult: LocationResultV3[] | undefined;
}

export class LocationResultV3 implements ILocationResultV3 {
    iD!: number | undefined;
    formattedAddress!: string | undefined;
    location!: Location | undefined;
    locationType!: string | undefined;
    boundingBox!: BoundingBox | undefined;

    constructor(data?: ILocationResultV3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iD = _data["ID"];
            this.formattedAddress = _data["FormattedAddress"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.locationType = _data["LocationType"];
            this.boundingBox = _data["BoundingBox"] ? BoundingBox.fromJS(_data["BoundingBox"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationResultV3 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResultV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD;
        data["FormattedAddress"] = this.formattedAddress;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["LocationType"] = this.locationType;
        data["BoundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationResultV3 {
    iD: number | undefined;
    formattedAddress: string | undefined;
    location: Location | undefined;
    locationType: string | undefined;
    boundingBox: BoundingBox | undefined;
}

export class SuggestionResponseV4 implements ISuggestionResponseV4 {
    suggestionResult!: string[] | undefined;

    constructor(data?: ISuggestionResponseV4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SuggestionResult"])) {
                this.suggestionResult = [] as any;
                for (let item of _data["SuggestionResult"])
                    this.suggestionResult!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionResponseV4 {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionResponseV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestionResult)) {
            data["SuggestionResult"] = [];
            for (let item of this.suggestionResult)
                data["SuggestionResult"].push(item);
        }
        return data;
    }
}

export interface ISuggestionResponseV4 {
    suggestionResult: string[] | undefined;
}

export class LocationResponseV4 implements ILocationResponseV4 {
    locationResult!: LocationResultV4[] | undefined;

    constructor(data?: ILocationResponseV4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LocationResult"])) {
                this.locationResult = [] as any;
                for (let item of _data["LocationResult"])
                    this.locationResult!.push(LocationResultV4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationResponseV4 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResponseV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationResult)) {
            data["LocationResult"] = [];
            for (let item of this.locationResult)
                data["LocationResult"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationResponseV4 {
    locationResult: LocationResultV4[] | undefined;
}

export class LocationResultV4 implements ILocationResultV4 {
    municipality!: string | undefined;
    zipcode!: string | undefined;
    thoroughfarename!: string | undefined;
    housenumber!: string | undefined;
    iD!: number | undefined;
    formattedAddress!: string | undefined;
    location!: Location | undefined;
    locationType!: string | undefined;
    boundingBox!: BoundingBox | undefined;

    constructor(data?: ILocationResultV4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.municipality = _data["Municipality"];
            this.zipcode = _data["Zipcode"];
            this.thoroughfarename = _data["Thoroughfarename"];
            this.housenumber = _data["Housenumber"];
            this.iD = _data["ID"];
            this.formattedAddress = _data["FormattedAddress"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.locationType = _data["LocationType"];
            this.boundingBox = _data["BoundingBox"] ? BoundingBox.fromJS(_data["BoundingBox"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationResultV4 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResultV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Municipality"] = this.municipality;
        data["Zipcode"] = this.zipcode;
        data["Thoroughfarename"] = this.thoroughfarename;
        data["Housenumber"] = this.housenumber;
        data["ID"] = this.iD;
        data["FormattedAddress"] = this.formattedAddress;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["LocationType"] = this.locationType;
        data["BoundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationResultV4 {
    municipality: string | undefined;
    zipcode: string | undefined;
    thoroughfarename: string | undefined;
    housenumber: string | undefined;
    iD: number | undefined;
    formattedAddress: string | undefined;
    location: Location | undefined;
    locationType: string | undefined;
    boundingBox: BoundingBox | undefined;
}

/** [Optional] The location types you want to restrict the result to. Valid types are 'Municipality' (1), 'Thoroughfarename' (2), 'Housenumber' (3). The filter has no effect on reverse geocoding requests. */
export enum Type {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** [Optional] The location types you want to restrict the result to. Valid types are 'Municipality' (1), 'Thoroughfarename' (2), 'Housenumber' (3). The filter has no effect on reverse geocoding requests. */
export enum Type2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ApiException extends Error {
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super(message);

        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}